import React from 'react'
import { Helmet } from 'react-helmet'
import MegaMenu from '../components/MegaMenu/MegaMenu'
import ServicesPageBanner from '../components/services-page-banner/ServicesPageBanner'
import TrustedPartner from '../components/trustedPartners/TrustedPartner'
import OurServices from '../components/our-services/OurServices'
import HirePageTestimonial from '../components/hire-page-testimonial/HirePageTestimonial'
import NewTeamSection from '../components/new-team-section/NewTeamSection'
import NewCaseStudySection from '../components/new-case-study-section/NewCaseStudySection'
import HireCombinationSection from '../components/hire-combination-sectiono/HireCombinationSection'
import WhyChooseBitsclan from '../components/why-choose-bitsclan/WhyChooseBitsclan'
import SimpleModels from '../components/simpleEngagementModels'
import CoverTheStack from '../components/coverthestack/CoverTheStack'
import HirePageSteps from '../components/hire-page-steps/HirePageSteps'
import ChallengeSection from '../components/challenge-section/ChallengeSection'
import HirePageSolutionSection from '../components/hire-page-solution-section/HirePageSolutionSection'
import WhyChooseUs from '../components/why-choose-us/WhyChooseUs'
import TrendsInsights from '../components/trends-n-insights/TrendsInsights'
import SoftwareCompanyCta from '../components/software-company-cta/SoftwareCompanyCta'
import { hireDevOpsData } from '../data/hire-devops.data'
import Footer from '../components/footer/Footer'
import SecondFaq from '../components/secondFaq/SecondFaq'
import NewCtaSection from '../components/new-cta-section/NewCtaSection'

const HireDevOps = () => {
    return (
        <>
            <Helmet>
                <title>Hire DevOps Engineers USA | Cloud, CI/CD & Automation Specialists</title>
                <meta name="description" content="Accelerate your business with expert DevOps engineers from Bitsclan. Hire US DevOps talent for cloud migrations, CI/CD pipelines, automation, and infrastructure scaling. Achieve faster, more reliable software delivery start now!" />
            </Helmet>

            <MegaMenu />

            <ServicesPageBanner
                shortHeading={hireDevOpsData?.mainBanner?.shortHeading}
                mainHeading={hireDevOpsData?.mainBanner?.mainHeading}
                description={hireDevOpsData?.mainBanner?.content}
            />
            <TrustedPartner heading="Trusted & Partnered by Businesses Worldwide to Build High Performance Machine Learning Solutions" />

            <OurServices
                shortHeading={hireDevOpsData?.flutterExpertise?.shortHeading}
                mainHeading={hireDevOpsData?.flutterExpertise?.heading}
                description={hireDevOpsData?.flutterExpertise?.description}
                servicesCardsData={hireDevOpsData?.flutterExpertise?.servicesData}
                buttonText="Start Your Project"
            />

            <HirePageTestimonial
                shortHeading="Some of Our Happy Clients"
                mainHeading="Trusted <span>Partnerships.</span> Proven Data Excellence"
                description="Clients partner with us for transparency, reliability, and measurable impact. Our Data Scientists and Engineers deliver insight-driven systems designed for scalability, speed, and long-term business value."
                testimonials={hireDevOpsData?.testimonialsData}
            />

            <NewTeamSection
                shortHeading={"Our Team"}
                mainHeading={"Introducing Our Expert Data Science Team"}
                description={"Our specialized Data Scientists and Engineers manage every stage, from data collection and model development to deployment and real-time analytics, delivering scalable solutions that turn data into actionable insights and drive business growth."}
            />

            <NewCtaSection content={hireDevOpsData?.ctaSection} />

            {/* <NewTestimonials
                shortHeading=" Some of Our Happy Clients"
                mainHeading="What Our Clients Say About Bitsclan's <span>Flutter Expertise</span>"
                description="We take pride in our flutter app development services, earning positive feedback from clients who value our dedication, quality, & reliable results. Their satisfaction inspires us to deliver exceptional mobile solutions every time."
            /> */}

            <NewCaseStudySection
                shortHeading="Our Clients Journey"
                heading="Transforming Data into Business Growth with Data Science Solutions"
                description="Explore how our Data Scientists and Engineers help businesses turn complex data into actionable insights, optimize workflows, and drive predictive modeling and real-time analytics, resulting in enhanced performance and measurable business outcomes across industries."
            />

            {/* <DevelopmentPerformance
        buttonText={whyChooseUs.btnText}
        heading={whyChooseUs.heading}
        greenHeading={whyChooseUs.greenHeading}
        subHeading={whyChooseUs.subHeading}
        solutions={whyChooseUs.solutionsData}
      /> */}

            <HireCombinationSection
                shortHeading={hireDevOpsData?.techCombinations?.shortHeading}
                combinations={hireDevOpsData?.techCombinations?.combinations}
                heading={hireDevOpsData?.techCombinations?.heading}
                description={hireDevOpsData?.techCombinations?.description}
            />

            <WhyChooseBitsclan
                tabs={hireDevOpsData?.whyChooseBitsclanContet}
                expandAllAccordions={true}
                shortHeading={"How We Work"}
                heading={"Here’s why leading companies trust us with their Data Science teams"}
                subheading={"From data collection to real-time analytics, we’ve perfected every stage of our process to deliver actionable insights and measurable business impact. Our approach guarantees transparency, speed, and quality, helping you turn raw data into strategic value faster. <br/> <br/> With us, you get a reliable data science partner focused on performance, efficiency, and transformational success."}
                ctaText={"Contact Our Experts"}
            />

            <SimpleModels content={hireDevOpsData?.engagementModels} />

            <CoverTheStack
                shortHeading={"Our Tech Stacks"}
                whereStart={"CI/CD & Automation"}
                mainHeading={"Comprehensive Machine Learning Expertise"}
                subHeading={"Our engineers utilize a modern tech stack designed for scalability, performance, and real-world impact. With hands-on experience across 100+ tools and frameworks, we provide end-to-end ML solutions from data engineering and model development to deployment, monitoring, and continuous optimization."}
                tabs={hireDevOpsData?.coverTheStack.tabs}
                tabItems={hireDevOpsData?.coverTheStack.tabItems}
            />

            <HirePageSteps
                buttonText={hireDevOpsData?.hireSteps.btnText}
                heading={hireDevOpsData?.hireSteps.heading}
                subHeading={hireDevOpsData?.hireSteps.subHeading}
                steps={hireDevOpsData?.hireSteps.steps}
            />

            <ChallengeSection
                mainHeading={"Top Challenges in Data Hiring & Development"}
                description={"Top Challenges in Data Science Implementation"}
                content={hireDevOpsData?.challengesData}
            />

            <HirePageSolutionSection
                shortHeading="Machine Learning Solutions We Build"
                mainHeading="How We Solve Machine Learning Challenges"
                description="We simplify the process of managing, scaling, and optimizing Machine Learning teams. Our approach tackles every challenge  from onboarding to deployment ensuring that your projects move seamlessly from concept to production with measurable success."
                content={hireDevOpsData?.mlSolutionsData}
            />

            <WhyChooseUs
                heading={hireDevOpsData?.whyUsContent?.heading}
                greenHeading={hireDevOpsData?.whyUsContent?.greenHeading}
                shortHeading={hireDevOpsData?.whyUsContent?.shortHeading}
                content={hireDevOpsData?.whyUsContent?.content}
                stats={hireDevOpsData?.whyUsContent?.stats}
                cta={hireDevOpsData?.whyUsContent?.cta}
                sectionImage={hireDevOpsData?.whyUsContent?.image}
            />

            {/* <HireExpertFacts
        buttonText={expertFacts.btnText}
        heading={expertFacts.heading}
        greenHeading={expertFacts.greenHeading}
        facts={expertFacts.facts}
        diffBannerBackgroundImage={expertFacts.backgroundImage}
      />

      <HirePageAppIdea
        heading={appIdeaSection?.heading}
        content={appIdeaSection.content}
      /> */}

            {/* <HirePageEngagmentModels
        buttonText={hirePageEngagementModels.btnText}
        heading={hirePageEngagementModels.headingContent}
        content={hirePageEngagementModels.discription}
        hiringDetails={hirePageEngagementModels.hiringDetails}
      /> */}

            {/* <SimpleModels content={engagementModelsContent} /> */}

            <TrendsInsights heading="Only show blogs related to DevOps" description="Here’s the revised version of the Machine Learning FAQs section, with the word 'hire' replaced and the content focused on business impact" specificClass="mobile-dev-page" category="all" />

            {/* <SecondFaq
                specificClass="mobile-dev-page"
                faqs={hireDevOpsData?.faqSection.faqData}
                mainHeading={hireDevOpsData?.faqSection.mainHeading}
                subHeading={hireDevOpsData?.faqSection.subHeading}
            /> */}

            {/* <ContactSection /> */}
            <SecondFaq
                specificClass="mobile-dev-page"
                faqs={hireDevOpsData?.faqSection.faqData}
                mainHeading={hireDevOpsData?.faqSection.mainHeading}
            />

            <SoftwareCompanyCta content={hireDevOpsData?.comapnyCtaContent} />

            <Footer />
        </>
    )
}

export default HireDevOps